import React from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@center/ui-kit'
import Popup from '../Popup'
import { buildBuildingIcon, buildSiteIcon } from './helpers'

const useMarker = ({ google, infoWindow, color, onClick, popupContent, iconType, disablePopup = false }) => {
  let infoWindowRoot = null
  let popup = null
  let currentMarker = null

  const create = (marker) => {
    const icon = typeof iconType === 'function' ? iconType(marker) : iconType
    return new google.maps.Marker({
      ...marker,
      icon: icon === 'house' ? buildBuildingIcon(google, color(marker)) : buildSiteIcon(google, color(marker))
    })
  }

  const openPopup = async (marker) => {
    currentMarker = marker
    
    if (!infoWindowRoot) {
      infoWindowRoot = createRoot(infoWindow.current)
    }
    
    infoWindowRoot.render(
      <ThemeProvider>
        <Popup loading sitecolor={color(marker)} />
      </ThemeProvider>
    )

    const content = await popupContent(marker)
    if (infoWindowRoot && currentMarker === marker) {
      infoWindowRoot.render(
        <ThemeProvider>
          <Popup 
            content={content} 
            sitecolor={color(marker)}
            onPopupEnter={() => {
              popup = { mouseover: true }
            }}
            onPopupLeave={() => {
              popup = { mouseover: false }
              closePopup()
            }}
          />
        </ThemeProvider>
      )
    }
  }

  const closePopup = () => {
    if (!popup?.mouseover && infoWindowRoot) {
      infoWindowRoot.render(null)
      currentMarker = null
    }
  }

  const add = (newMarker) => {
    const marker = create(newMarker)

    if (!disablePopup) {
      marker.addListener('mouseover', async () => {
        await openPopup(marker)
      })

      marker.addListener('mouseout', () => {
        popup = { mouseover: false }
        closePopup()
      })
    }

    marker.addListener('click', () => {
      if (infoWindowRoot) {
        infoWindowRoot.render(null)
      }
      currentMarker = null
      popup = null
      onClick(marker)
    })
    
    return marker
  }

  return add
}

export default useMarker
